import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Send, Smile } from 'lucide-react';
interface ChatScreenProps {
  isOpen: boolean;
  onClose: () => void;
  friendName: string;
  friendAvatar: string;
}
const QUICK_MESSAGES = ['Good game! 🎮', 'Want to play? 🎯', 'Nice move! 👏', "Let's go! 🔥", 'One more? 🎲', 'GG! 🏆'];
export function ChatScreen({
  isOpen,
  onClose,
  friendName,
  friendAvatar
}: ChatScreenProps) {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState<Array<{
    text: string;
    sender: 'me' | 'friend';
    time: string;
  }>>([{
    text: 'Hey! Want to play?',
    sender: 'friend',
    time: '2:30 PM'
  }, {
    text: "Sure! Let's do it",
    sender: 'me',
    time: '2:31 PM'
  }]);
  const handleSend = () => {
    if (message.trim()) {
      setMessages([...messages, {
        text: message,
        sender: 'me',
        time: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      }]);
      setMessage('');
    }
  };
  const handleQuickMessage = (msg: string) => {
    setMessages([...messages, {
      text: msg,
      sender: 'me',
      time: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    }]);
  };
  return <Modal isOpen={isOpen} onClose={onClose} title={`Chat with ${friendName}`} className="max-w-md h-[600px]" data-id="element-196">
      <div className="flex flex-col h-full" data-id="element-197">
        {/* Messages */}
        <div className="flex-1 overflow-y-auto space-y-3 mb-4" data-id="element-198">
          {messages.map((msg, index) => <div key={index} className={`flex ${msg.sender === 'me' ? 'justify-end' : 'justify-start'}`} data-id="element-199">
              <div className={`max-w-[70%] ${msg.sender === 'me' ? 'order-2' : 'order-1'}`} data-id="element-200">
                <div className={`rounded-2xl px-4 py-2 ${msg.sender === 'me' ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-900'}`} data-id="element-201">
                  {msg.text}
                </div>
                <div className="text-xs text-slate-400 mt-1 px-2" data-id="element-202">
                  {msg.time}
                </div>
              </div>
              {msg.sender === 'friend' && <div className="w-8 h-8 rounded-full bg-gradient-to-br from-violet-400 to-purple-500 flex items-center justify-center text-lg mr-2 order-1" data-id="element-203">
                  {friendAvatar}
                </div>}
            </div>)}
        </div>

        {/* Quick Messages */}
        <div className="flex gap-2 mb-3 overflow-x-auto pb-2" data-id="element-204">
          {QUICK_MESSAGES.map((msg, index) => <button key={index} onClick={() => handleQuickMessage(msg)} className="flex-shrink-0 px-3 py-1 bg-slate-100 hover:bg-slate-200 rounded-full text-sm font-medium text-slate-700 transition-colors" data-id="element-205">
              {msg}
            </button>)}
        </div>

        {/* Input */}
        <div className="flex gap-2" data-id="element-206">
          <input type="text" value={message} onChange={e => setMessage(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSend()} placeholder="Type a message..." className="flex-1 px-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-207" />
          <Button onClick={handleSend} className="gap-2" data-id="element-208">
            <Send size={18} data-id="element-209" />
          </Button>
        </div>
      </div>
    </Modal>;
}